module.exports = __webpack_public_path__ + "img/screen.32206674.png";